<template>
  <div class="screen" :class="seasonClass">
    <div class="page" :class="group === 1 ? 'page2' : ''">
      <div class="userinfo" v-if="padUserInfo.userName && !dialogVisible && waitForExam"><span class="mr-20">姓名：{{ padUserInfo.userName }}</span><span>比赛号码：{{ addZero(padUserInfo.matchNum) }}</span></div>

      <!-- logo -->
      <img class="logo" v-if="seasonClass === 'season1'" src="https://cdn.spbcn.org/chineseWord/applets/images/final_center.png" @click="goBack">
      <div class="season2-logo" v-if="seasonClass === 'season2'">
        <img class="img" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/logo.png" alt="">
        <img class="img" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season3/season3.png" alt="">
      </div>
      <div class="page-box">
        <div class="info-title header" :class="group === 1 ? 'info-title2' : ''">
          <div class="cn">{{cnTitle}}1</div>
          <div class="en">{{enTitle}}</div>
        </div>
        <template v-if="waitForExam">
          <div class="title title2">
            <!-- <template v-if="matchStart">
              <div>比赛开始，比赛过程中请不要切出答题页面</div>
              <div>The competition has started, please do not cut out the answer page during the competition process</div>
            </template> -->
            <!-- <template v-else> -->
              <img class="guodu" :src="seasonClass === 'season1' ? 'https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_padU86_guodu_icon.png' : 'https://cdn.spbcn.org/chineseWord/applets/images/logo_yuan.png'" alt="">
              <div>参赛信息已确认，请耐心等待比赛开始</div>
              <div class="word-break">Your information has been confirmed. Please be patient and wait for the competition to begin.</div>
            <!-- </template> -->
          </div>
        </template>
        <template v-else>
            <div class="title">请输入你的比赛号码 ｜ Please enter your race number</div>
            <el-input class="input" v-model="queryForm.matchNum" type="number" :readonly="dialogVisible"></el-input>
            <div class="search" @click="getInfo">登录 | Login</div>
        </template>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" :show-close="false" :close-on-click-modal="false" :custom-class="seasonClass === 'season1' ? '' : 'season2-dialog'" :width="seasonClass === 'season1' ? '680px' : getDialogWidth()">
      <div class="info-panel" :class="'info-panel-'+seasonClass">
        <div class="info-title">
          <div class="cn">请确认你的个人信息</div>
          <div class="en word-break">Please confirm your information.</div>
        </div>
        <div class="info-con">
          <div class="info-item" v-for="(value, key) in info" :key="key">
            <div class="key">
              <div class="cn">{{ key }}</div>
              <div class="en">{{ getEn(key) }}</div>
            </div>
            <div class="value">
              {{ value }}
            </div>
          </div>
        </div>
        <div class="info-btns">
          <div class="btn btn1" @click="closeFn">返回 | Cancel</div>
          <div class="btn btn2" @click="confirmFn">确认 | Confirm</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      seasonClass: '',
      queryForm: {
        matchNum: '',
        activityType: this.$chnEngStatusCode.activityType,
        season: '',
        isGroup: Number(this.$route.query.group)
      },
      info: {},
      userLevel: '',
      userId: '',
      dict_grade: this.$userInfo.getGradeData(),
      dict_group: this.$userInfo.dict_group(),
      group: 1, // 1-有组别 2无组别
      cnTitle: '',
      enTitle: '',
      dialogVisible: false,
      waitForExam: false,
      timer: null,
      questionTimer: null,
      matchStart: false,
      loading: false,
      raceSchedule: '', // 赛程
      padUserInfo: {} // 个人信息
    }
  },
  created () {
    document.title = '汉英双拼大会'
    clearInterval(this.timer)
    this.group = Number(this.$route.query.group)
    this.raceSchedule = this.$route.query.raceSchedule || '4'
    window.addEventListener('keydown', this.handkeyCode, true)
    this.setPage()
    const season = this.$route.query.season
    this.queryForm.season = season
    console.log('season', this.queryForm.season)
    // if (!this.queryForm.season) {
    this.getDefaultSeason()
    // }
    this.seasonClass = season === '2022~2023' ? 'season1' : season === '2023~2024' ? 'season2' : 'season2'
  },
  methods: {
    getDefaultSeason () {
      this.$http.get(`/season/seasonActivityIng/${this.queryForm.activityType}`).then(res => {
        if (res.code === 200) {
          const season = res.data.season
          this.queryForm.season = season
        }
      })
    },
    // 获取弹窗宽度
    getDialogWidth () {
      const screenWidth = window.innerWidth
      if (screenWidth < 768) {
        return '90%'
      } else if (screenWidth < 1024) {
        return '90%'
      } else if (screenWidth < 1440) {
        return '60%'
      } else {
        return '50%'
      }
    },
    goBack () {
      this.$confirm('确定返回上一页？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.back()
      }).catch(() => {
      })
    },
    setPage () {
      this.cnTitle = this.group === 1 ? '小组赛' : '无组别 挑战赛'
      this.enTitle = this.group === 1 ? 'Group Competition' : 'Mixed Group Competition'
    },
    handkeyCode (e) {
      if (e.keyCode === 13) {
        this.getInfo()
      }
    },
    getInfo () {
      if (!this.queryForm.matchNum) return
      if (this.loading) return
      this.loading = true
      this.queryForm.matchNum = this.addZero(this.queryForm.matchNum)
      this.$http.get('slabForm/queryPersonInfoByMatchNum', { params: this.queryForm }).then(res => {
        if (res.code === 200) {
          const obj = {}
          obj['姓 名'] = res.data.userName
          obj['手 机 号'] = res.data.phone
          obj['年 级'] = this.gradeFormatter(res.data.grade)
          obj['学 校'] = res.data.schoolName
          obj['比赛号码'] = this.addZero(res.data.matchNum)

          this.info = obj
          this.userId = res.data.id
          this.userLevel = res.data.level
          if (this.group === 1) {
            this.cnTitle = this.cnTitle + ' ' + this.levelFormatter(this.userLevel, 'cn')
            this.enTitle = this.enTitle + ' ' + this.levelFormatter(this.userLevel, 'en')
          }
          this.padUserInfo = res.data
          this.dialogVisible = true
        }
        this.loading = false
      }).catch(error => {
        console.log(error)
        this.loading = false
      })
    },
    getEn (key) {
      return key === '姓 名' ? 'Name' : key === '手 机 号' ? 'Phone' : key === '年 级' ? 'Grade' : key === '学 校' ? 'School' : key === '比赛号码' ? 'Race Number' : ''
    },
    addZero (num) {
      return this.$xcUtils.addZero(num)
    },
    gradeFormatter (grade) {
      return grade ? this.dict_grade.find(item => item.dictCode === grade).dictLabel : '--'
    },
    levelFormatter (level, type) {
      return this.dict_group.find(item => item.dictCode === level)[type]
    },
    // 确认比赛信息
    confirmFn () {
      this.$http.post('slabForm/saveNationalGroupIsLogin', { id: this.userId, isGroup: this.group, season: this.queryForm.season }).then(res => {
        if (res.code === 200) {
          this.closeFn()
          this.waitForExam = true
          // 将个人信息保存到本地缓存
          localStorage.setItem('PAD_USER_INFO', JSON.stringify(this.padUserInfo))
          this.getMatchStart()
          this.timer = setInterval(() => {
            this.getMatchStart()
          }, 3000)
        }
      })
    },
    // 查询考试开始状态
    getMatchStart () {
      console.log('获取考场状态')
      const params = {
        activityType: this.queryForm.activityType,
        season: this.queryForm.season,
        isGroup: this.group,
        raceSchedule: this.raceSchedule
      }
      if (Number(this.group) === 1) {
        params.level = this.userLevel
      }
      this.$http.get('slabForm/queryNationalGroupFormInfoList', { params, showLoading: false }).then(res => {
        if (res.code === 200) {
          // 获取到题目：跳转到答题(erp点击了开始答题)
          if (res.data.groupFormInfo && res.data.groupFormInfo.quizIng === 1) {
            this.nextPage()
          }
          // 开始比赛：提示比赛开始（erp点击了比赛开始）
          const matchTng = res.data.matchTng
          if (matchTng === 1) { // 比赛开始
            this.matchStart = true
          }
          if (matchTng === 2) {
            this.$router.push(`/pad/done?g=${this.group}&season=${this.queryForm.season}&raceSchedule=${this.raceSchedule}`) // 比赛结束
          }
        }
      })
    },
    nextPage () {
      clearInterval(this.timer)
      this.$router.push(`/pad/answer?s=${this.queryForm.season}&at=${this.queryForm.activityType}&l=${this.userLevel}&g=${this.group}&ra=${this.raceSchedule}`) // 跳转到答题页面
    },
    closeFn () {
      this.info = {}
      this.setPage()
      this.dialogVisible = false
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }

}
</script>
<style scoped lang="less">
.screen{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  font-family: 'regular';
}
.page{
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
}
.logo{
  width: 220px;
  position: fixed;
  left: 0;
  top: 32px;
  z-index: 10;
}
.title{
  margin: 60px auto 0;
  font-size: 26px;
  text-align: center;
  color: #000;
}
.title2{
  max-width: 80%;
  // margin-top: 120px;
}
.input{
  display: block;
  text-align: center;
  margin: 40px auto;
  width: 400px;
  height: 80px;
  border: 2px solid #000;
  border-radius: 20px;
  background-color: #fff;
  box-shadow: inset 2px 2px 15px rgba(0,0,0,0.4);
  /deep/ .el-input__inner {
    height: 70px;
    border: none;
    text-align: center;
    font-size: 46px;
    font-family: 'regular';
    color: #000;
    background-color: transparent;
    letter-spacing: 4px;
  }
}
.search{
  width: 300px;
  height: 58px;
  line-height: 54px;
  background: linear-gradient(to bottom, #0c0a03, #373633);
  color: #fff;
  font-size: 28px;
  font-family: 'regular';
  border-color: #000;
  border-radius: 58px;
  display: block;
  margin: 40px auto 0;
  text-align: center;
}
/deep/ .el-dialog__header{
  display: none;
}
/deep/ .el-dialog{
  background-color: transparent;
  box-shadow: none;
}
.info-panel{
  height: 410px;
  background-color: #cbae72;
  border-radius: 60px;
  border: 3px solid #000;
}
.info-title{
  margin: 20px auto 10px;
  width: 100%;
  height: 80px;
  padding-top: 16px;
  box-sizing: border-box;
  // line-height: 64px;
  text-align: center;
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_title_bg.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  color: #fff;
  .cn{
    font-size: 22px;
  }
  .en{
    font-size: 16px;
  }
}
.info-title2{
  color: #000;
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_title_bg2.png);
}
.info-con{
  width: 88%;
  height: 200px;
  border-radius: 60px;
  margin: 0 auto;
  background-color: #B81C25;
  color: #fff;
  font-size: 18px;
  font-family: fzcsk;
  // padding-left: 42px;
  padding-top: 6px;
  box-sizing: border-box;
}
.info-item{
  display: flex;
  .key{
    font-size: 14px;
    width: 100px;
    margin-left: 120px;
    margin-bottom: 8px;
  }
  .en{
    font-size: 12px;
  }
}
.info-btns{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  .btn{
    font-size: 22px;
    width: 220px;
    text-align: center;
    height: 48px;
    line-height: 44px;
    justify-content: center;
    border-radius: 48px;
    color: #fff;
  }
  .btn1{
    background: linear-gradient(to bottom, #0c0a03, #373633);
    margin-right: 40px;
  }
  .btn2{
    background-color: #b81c25;
  }
}
.header{
  height: 76px;
  padding-top: 10px;
  margin-top: 30px;
}
.guodu{
  width: 150px;
  height: 150px;
  margin-bottom: 24px;
}
.userinfo{
  position: absolute;
  right: 24px;
  top: 14px;
  color: #000;
  font-size: 16px;
  font-family: fzcsk;
  .mr-20{
    margin-right: 10px;
  }
}
.season1{
  .page{
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_padU86_bg2.png);
  }
}
.season1 .page2{
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_padU86_bg1.png);
}
.season2{
  .page{
    // background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/season2bg.png);
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/2025/season3_bg_pure.jpg);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .season2-logo{
    position: absolute;
    left: 40px;
    right: 40px;
    top: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .img{
      height: 40px;
      width: auto;
    }
  }
  .page-box{
    width: 86%;
    min-height: 70vh;
    background: rgba(255, 248, 225, .7);
    border-radius: 20px;
    padding: 1px 30px 30px;
    margin-top: 40px;
  }
  .userinfo{
    // top: 104px;
    // right: 58px;
    top: 88px;
    right: 40px;
  }
  .info-title{
    margin-top: 30px;
  }
  .header{
    margin-top: 40px;
  }
  .guodu{
    // margin-top: 40px;
    margin-bottom: 60px;
  }
}

.info-panel-season2{
  height: 520px;
  border: none;
  background-color: transparent;
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/rankbg.png);
  background-repeat: no-repeat;
  background-size: 90% 100%;
  background-position: center;
  padding-top: 50px;
  box-sizing: border-box;
  .info-con{
    width: 60%;
    background-color: transparent;
    color: #000;
  }
  .info-title{
    color: #fff;
  }
}
/deep/ .season2-dialog{
  // margin-top: 60px !important;
  margin-bottom: 0 !important;
  .el-dialog__body{
    padding: 0;
  }
}
</style>
